<template>
  <div class="switchBar">
    <el-tabs
      v-model="activeName"
      type="card"
      class="demo-tabs"
      @tab-click="handleClick"
    >
      <!--      <el-tab-pane label="反馈列表" name="first">-->
      <!--        <el-table :data="tableData" style="width: 100%">-->
      <!--          <el-table-column label="邮件" prop="feedbackEmail" />-->
      <!--          <el-table-column label="反馈描述" prop="feedbackDesc" />-->
      <!--          <el-table-column label="回复" prop="feedbackResult" />-->
      <!--          <el-table-column label="创建时间" prop="createTime" />-->

      <!--          <el-table-column align="right">-->
      <!--            <template #default="scope">-->
      <!--              <el-button-->
      <!--                v-if="activeName == 'first' && !scope.row.feedbackResult"-->
      <!--                type="warning"-->
      <!--                size="small"-->
      <!--                @click="-->
      <!--                  handleEdit(scope.$index, scope.row);-->
      <!--                  centerDialogVisible = true;-->
      <!--                "-->
      <!--                >回复</el-button-->
      <!--              >-->
      <!--            </template>-->
      <!--          </el-table-column>-->
      <!--        </el-table>-->
      <!--        <div class="pagination">-->
      <!--          <el-pagination-->
      <!--            background-->
      <!--            layout="prev, pager, next"-->
      <!--            :total="total"-->
      <!--            @current-change="handleCurrentChange"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="自定义反馈链接" name="second">
        <div class="link">
          <input type="text" v-model="feedbackLink" />
          <span @click="setLink">设置</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>

  <el-dialog
    v-model="centerDialogVisible"
    title=""
    width="500"
    center
    draggable
  >
    <div>
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item label="邮件">
          <el-input v-model="form.email" disabled />
        </el-form-item>
        <el-form-item label="反馈问题">
          <el-input v-model="form.question" disabled />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="form.content" type="textarea" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="pass"> 发送 </el-button>
      </div>
    </template>
  </el-dialog>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
} from "@element-plus/icons-vue";
import { ElMessageBox, TabsPaneContext } from "element-plus";
import { Form, GameData } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "second",
      tableData: [],
      status: 0,
      centerDialogVisible: false,
      feedbackLink: "",
      form: {
        id: "",
        email: "",
        content: "",
        question: "",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {
    let game = this.$store.state.game.games.find((item: any) => {
      return item.id == this.$route.params.id;
    });

    if (game.feedbackLink) {
      this.feedbackLink = game.feedbackLink;
    }
  },
  created() {
    this.fetchGameList(this.currentPage, this.$route.params.id);
  },
  methods: {
    fetchGameList(pageNum: number, gameId: string) {
      const pageSize = 10;
      this.$store
        .dispatch("game/getFeedbackList", { pageNum, pageSize, gameId })
        .then((res: any) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {});
    },
    handleCurrentChange(val: number) {
      this.fetchGameList(val, this.$route.params.id);
    },
    handleEdit(index: number, row: any) {
      this.form.id = row.feedbackId;
      this.form.question = row.feedbackDesc;
      this.form.email = row.feedbackEmail;
    },
    handleClick(tab: TabsPaneContext) {
      this.status =
        tab.paneName === "first" ? 0 : tab.paneName === "second" ? 1 : 2;
      this.fetchGameList(1, this.status);
    },
    noPass() {
      ElMessageBox.prompt("请输入失败原因", "Tip", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.updateGame(this.form.id, 2, value);
        })
        .catch(() => {});
    },
    pass() {
      this.updateGame();
    },
    updateGame() {
      this.$store
        .dispatch("game/UpdateFeedback", { ...this.form })
        .then(() => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
      this.centerDialogVisible = false;
    },
    setLink() {
      if (this.feedbackLink) {
        this.$store
          .dispatch("game/UpdateFeedbackLink", {
            id: this.$route.params.id,
            link: this.feedbackLink,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.link {
  width: 80%;
  height: 6vw;
  max-height: 50px;
  max-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  padding: 20px;

  input {
    width: 88%;
    height: 100%;
    outline: none;
    border: 1px solid #000;
    text-indent: 10px;

    &:focus {
      border-color: #2da8e0;
    }
  }

  span {
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background: #000;
    font-size: 1.2vw;
  }
}
</style>
